import React from 'react';
import styled from '@emotion/styled';
import { useRecoilValue } from 'recoil';
import { BLACK, GRAY } from '../../../../../styles/constants/color';
import { fontFrame } from '../../../../../styles/mixin/font';
import { otherBankInfoState } from '../../../../../data/estimate/common/otherBank/info/selector';
import useCalculatorForOtherBankCondition from '../../../../../hooks/estimate/common/otherBank/useCalculatorForOtherBankCondition';

const Select = styled.select`
  width: 53px;
  height: 25px;
  border: 1px solid ${GRAY};
  ${fontFrame('400', '11px', '1', BLACK)};
`;

// 고정된 선수율 목록
const ADVANCE_RECEIVED_RATE_LIST: (number | string)[] = Array.from(
  { length: 100 },
  (v: unknown, i: number) => i
).map((num: number) => (num === 0 ? '전액' : num)); // [0, ..... 99];

/**
 *  타금융사 할부조건 선수율 select 로직
 */
function OtherBankAdvanceReceivedRate(): JSX.Element {
  // selected
  const value: number = useRecoilValue(
    otherBankInfoState({ name: 'otherBankAdvanceReceivedRate' })
  ); // 선수율
  const principalType: string = useRecoilValue(
    otherBankInfoState({ name: 'otherBankPrincipalType' })
  ); // 원금 타입

  // function
  const { updateInstallment } = useCalculatorForOtherBankCondition();
  const onChange = (e: React.ChangeEvent<HTMLSelectElement>): void => {
    const advanceReceivedRate: number = Number(e.target.value);
    updateInstallment({
      inputName: 'advanceReceivedRate',
      inputValue: advanceReceivedRate,
    });
  };
  return (
    <Select value={value} onChange={onChange} disabled={principalType !== 'advanceReceivedRate'}>
      {!!ADVANCE_RECEIVED_RATE_LIST?.length &&
        ADVANCE_RECEIVED_RATE_LIST.map((rate: number | string) => (
          <option key={rate} value={rate === '전액' ? 0 : rate}>
            {rate === '전액' ? '전액' : `${rate}%`}
          </option>
        ))}
    </Select>
  );
}

export default OtherBankAdvanceReceivedRate;
